<mat-form-field>
  <mat-label>{{ to.label }}</mat-label>
  <input
    type="color"
    class="color-input"
    [formControl]="formControl"
    [formlyAttributes]="field"
    (focus)="onFocus($event)"
    matInput
  />
</mat-form-field>
